

















import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
export default Vue.extend({
  name: "UserSendMail",
  components: { Modal, Paragraph },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onValidate: {
      type: Function,
      default: () => undefined
    },
    onAction: {
      type: Function,
      default: () => undefined
    },
    user: {
      type: Object
    }
  },
  data: () => {
    return {
      title: "Mail de remise à zéro de mot de passe",
      loading: false
    };
  },
  methods: {
    async onClickHandler(): Promise<void> {
      this.loading = true;
      if (await this.onValidate(this.user._id)) {
        this.loading = false;
        this.onAction({
          type: "SUCCESS",
          title: "Envoie de l'Email",
          content: `L'email a bien été envoyé.`
        });
        this.onClose();
      } else {
        this.loading = false;
        this.onAction({
          type: "ERROR",
          title: "Envoie de l'Email",
          content: `Une erreur s'est produite lors de l'envoi de l'email`
        });
      }
    }
  }
});
